import { useEffect, useState } from 'react'
import AMapLoader from '@amap/amap-jsapi-loader'
import locationImg from './assets/location.png'

const defaultCenter = [116.83379593647048, 39.61736734567014]

const mapConfig = {
  key: '0e4f7b5e424e7db93755cb5d48e71a75',
  version: '2.0',
  plugins: [
    // 'AMap.MouseTool',
    // 'AMap.PolyEditor',
    // 'AMap.Geocoder',
    // 'AMap.AutoComplete',
    // 'AMap.PlaceSearch',
    'AMap.GeoJSON',
  ],
  Loca: {
    version: '2.0.0',
  },
}

let AMapCache = null
let mapLoading = false
let callback = []
const loadAMap = () => {
  return new Promise((resolve) => {
    if (AMapCache) {
      resolve(AMapCache)
    } else if (mapLoading) {
      callback.push(resolve)
    } else {
      mapLoading = true
      AMapLoader.load(mapConfig).then((Amap) => {
        AMapCache = Amap
        mapLoading = false
        resolve(Amap)
        callback.forEach((res) => res(Amap))
        callback = []
      })
    }
  })
}

const useAmap = (containerSlug) => {
  const [AMap, setAMap] = useState(null)
  const [amap, setAmap] = useState(null)

  // 初始化地图
  const init = (theme) => {
    return loadAMap()
      .then((Amap) => {
        const _amap = new Amap.Map(containerSlug, {
          center: defaultCenter,
          zoom: 14,
          mapStyle: `amap://styles/${theme}`,
        })
        setAMap(Amap)
        setAmap(_amap)
        return Amap
      })
      .catch((err) => {
        console.log('useAmap', err)
      })
  }

  const activeMarkerContent = () => {
    return (
      '<div class="custom-content-marker" >' +
      '   <img class="custom-icon" src="' +
      locationImg +
      '" />' +
      '</div>'
    )
  }

  const setCenter = (c) => {
    amap.setCenter(c)
  }

  // jeojson回显
  // 回显
  const showJeojson = (jeoJSON) => {
    const geoJson = new AMap.GeoJSON({
      geoJSON: jeoJSON,
      getPolygon: (geojson, lnglats) => {
        const polygon = new AMap.Polygon({
          path: lnglats,
          strokeColor: '#0056fe',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: 'white',
          fillOpacity: 0,
          strokeStyle: 'solid',
          // draggable: true,
          // cursor: 'move',
        })

        return polygon
      },
      getMarker: ({ geometry }) => {
        const { coordinates } = geometry
        let options = {}
        if (coordinates) {
          options = {
            position: coordinates,
            content: activeMarkerContent(),
            // draggable: true,
            // cursor: 'move',
          }
        }
        const marker = new AMap.Marker(options)
        return marker
      },
    })

    amap.add(geoJson)
  }

  useEffect(() => {
    return () => {
      if (amap) {
        amap.destroy()
      }
    }
  }, [amap])

  return {
    init,
    amap,
    AMap,
    setCenter,
    activeMarkerContent,
    showJeojson,
  }
}
export default useAmap
